import { podcastUrl } from '@root/common/filters/urlBuilders';
import { Podcast as PodcastData } from '@root/modules/podcast/types/podcast';

type Variables = { podcast: PodcastData; domain: string | string[]; fakeDomainEnabled: boolean; articlesLinksHash?: string };

export default function getPodastWithHref({ podcast, domain, fakeDomainEnabled, articlesLinksHash }: Variables): PodcastData {
  const href = podcastUrl({ article: podcast, domain, fakeDomainEnabled, articlesLinksHash });
  const podcastWithHref = { ...podcast, href };
  return podcastWithHref;
}
